export enum OwnerDetailsTabDescriptionEnum {
  BASIC = 'owner.details.tab.basic',
  CARDS = 'owner.details.tab.cards',
  PERSONAL = 'owner.details.tab.personal',
  SYSTEM = 'owner.details.tab.system',
}
